//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { Scrim } from '@legacy-components/nav3/navigation-menus/Scrim';
import { TOP_NAV_BAR_HEIGHT } from '@legacy-components/nav3/navigation-menus/constants/NavMenuItemConstants';
import { CommerceNav } from '@legacy-components/nav3/navigation-menus/menu-dropdown-items/CommerceNav';
import { ContentNav } from '@legacy-components/nav3/navigation-menus/menu-dropdown-items/ContentNav';
import { CreatorsNav } from '@legacy-components/nav3/navigation-menus/menu-dropdown-items/CreatorsNav';
import { PublishingNav } from '@legacy-components/nav3/navigation-menus/menu-dropdown-items/PublishingNav';
import { AgentsDashboardNav } from '@legacy-components/nav3/navigation-menus/menu-items/AgentsDashboardNav';
import { CampaignsNav } from '@legacy-components/nav3/navigation-menus/menu-items/CampaignsNav';
import { HomeNav } from '@legacy-components/nav3/navigation-menus/menu-items/HomeNav';
import { InboxNav } from '@legacy-components/nav3/navigation-menus/menu-items/InboxNav';
import { InsightsNav } from '@legacy-components/nav3/navigation-menus/menu-items/InsightsNav';
import { ListeningNav } from '@legacy-components/nav3/navigation-menus/menu-items/ListeningNav';
import { SamplingNav } from '@legacy-components/nav3/navigation-menus/menu-items/SamplingNav';
import { useModeratorSurface } from '@moderation-mode/hooks/useModeratorSurface';
import makeAngularReactController from '@react-bridge/angular-react-widget';
import {
  getIsShareV2Vendor,
  getIsSyndicationClient,
} from '@redux/selectors/getSessionInfo';
import { getIsBazaarvoiceNetworkSyndicationFrontendEnabled } from '@uia/rights/selectors/getUIARights';

export const NavMenuTabs = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isBazaarvoiceSyndicationEnabled = useSelector(
    getIsBazaarvoiceNetworkSyndicationFrontendEnabled,
  );

  const isSyndicationClient = useSelector(getIsSyndicationClient);
  const isShareV2VendorClient = useSelector(getIsShareV2Vendor);
  const { isModeratorSurface: isModeratorView } = useModeratorSurface();

  const isLegacySyndicationOrConnectClient =
    (isSyndicationClient || isShareV2VendorClient) &&
    !isBazaarvoiceSyndicationEnabled;

  if (isLegacySyndicationOrConnectClient) {
    return null;
  }

  /**
   * Moderator View is Content-only; the route guard enforces the same boundary
   * for deep links.
   */
  if (isModeratorView) {
    return (
      <NavMenu>
        <ContentNav setIsMenuOpen={setIsMenuOpen} />
        <Scrim isOpen={isMenuOpen} />
      </NavMenu>
    );
  }

  return (
    <NavMenu>
      <HomeNav />
      <AgentsDashboardNav />
      <CreatorsNav setIsMenuOpen={setIsMenuOpen} />
      <SamplingNav />
      <CampaignsNav />
      <ContentNav setIsMenuOpen={setIsMenuOpen} />
      <PublishingNav setIsMenuOpen={setIsMenuOpen} />
      <InboxNav />
      <CommerceNav setIsMenuOpen={setIsMenuOpen} />
      <ListeningNav />
      <InsightsNav />
      <Scrim isOpen={isMenuOpen} />
    </NavMenu>
  );
};

const NavMenu = styled.div(
  ({ theme }) => `
    display: inline-flex;
    align-items: center;
    height: ${TOP_NAV_BAR_HEIGHT};
    font-weight: ${theme.fontWeights.semiBold};
  `,
);

angular.module('curalate').component('navMenuTabs', {
  controller: makeAngularReactController(<NavMenuTabs />),
});
